import { FC } from "react";
import { ButtonProps, Drawer, DrawerProps, Create, FormProps, Grid } from "@pankod/refine-antd";
import { useTranslate } from "@pankod/refine-core";

import { CreateEditForm } from "./createEditForm";

interface Props {
  drawerProps: DrawerProps;
  formProps: FormProps;
  saveButtonProps: ButtonProps;
  formLoading: boolean;
}

export const CreateDelivery: FC<Props> = props => {
  const { drawerProps, formProps, saveButtonProps, formLoading } = props;
  const breakpoint = Grid.useBreakpoint();
  const t = useTranslate();

  return (
    <Drawer
      {...drawerProps}
      width={breakpoint.sm ? "500px" : "100%"}
      bodyStyle={{ padding: 0 }}
      zIndex={1001}
      title={t("deliveries.titles.create")}
      destroyOnClose
      forceRender
    >
      <Create
        resource="deliveries"
        headerProps={{ extra: null }}
        goBack={null}
        breadcrumb={false}
        title={false}
        saveButtonProps={saveButtonProps}
        isLoading={formLoading}
      >
        {CreateEditForm(formProps, t, false, !!drawerProps?.open)}
      </Create>
    </Drawer>
  );
};
